/**
 * The write-side and cache-side counterparts to `useSiloQuery`'s injection.
 *
 * A write names the locale its text is authored in, so these take the
 * datastore's current language and never `'*'`: "every locale" is not a
 * language something can be written in.
 *
 * They also address a read's cache entry from outside React. `setQueryData` and
 * `getQueryData` match a query key exactly, not by prefix, so a hand-built key
 * has to carry the same locale the hook sent or the patch lands on nothing and
 * says nothing. Spreading `instanceParamsOf(datastore)` into the input a key is
 * derived from is what keeps the two in step — the datastore's `getLanguage()`
 * and the `useLanguage()` the hooks read are the same piece of state, so they
 * cannot disagree.
 */
import type { IsoLocale } from '@repo/shared/locale';
import type { Datastore } from 'util/datastore';

export function siloParamsOf(datastore: Datastore): { siloKey: string; locale: IsoLocale } {
    return { siloKey: datastore.getSiloKey(), locale: datastore.getLanguage() };
}

/** `siloParamsOf` plus the current instance, matching `useInstanceQuery`. */
export function instanceParamsOf(datastore: Datastore): { siloKey: string; spaceKey: string; locale: IsoLocale } {
    return { ...siloParamsOf(datastore), spaceKey: datastore.getInstanceKey() };
}
